"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactVis = require("react-vis");

var _styles = require("../styles");

require("./noDataInsert.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var noDataInsert = function noDataInsert(start, end, isLoading) {
  for (var _len = arguments.length, setsToCheck = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    setsToCheck[_key - 3] = arguments[_key];
  }

  if (setsToCheck.some(function (s) {
    return s.length;
  })) return [];
  return [!isLoading && /*#__PURE__*/_react["default"].createElement(_reactVis.ChartLabel, {
    className: "no-data",
    key: "no-data",
    text: "No Data",
    xPercent: 0.5,
    yPercent: 0.5,
    includeMargin: false,
    style: {
      dominantBaseline: 'middle',
      textAnchor: 'middle'
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactVis.LineSeries, {
    key: "space-filling-line",
    data: [{
      x: start,
      y: -1
    }, {
      x: end,
      y: 1
    }],
    style: _styles.invisibleLineStyle
  })];
};

var _default = noDataInsert;
exports["default"] = _default;